import { 
    useState, 
    useEffect, 
    useReducer,
    useRef,
    useCallback,
    useContext,
    createContext
} from 'react';

import { 
    motion, 
    AnimatePresence 
} from 'framer-motion';


import WpBlockCwcSlide from '../../slide/src/view.jsx';

import { 
    SettingsContext,
    ActionContext,
    parseStyleAttribute
} from '../../../src/view.jsx';


export default function WpBlockCwcSlides( {
    children: innerBlocks,
    className,
    ...otherProps
} ) {
    const { 
        currentIndex: [
            prev,
            current,
            next
        ],
        processing
    } = useContext( ActionContext )

    const {
        children: innerBlock,
        ['data-attributes']: attributes,
        ...innerBlockProps
    } = innerBlocks[current].props


    return (
        <div 
            {...otherProps}
            className={ `${className}${processing ? ' is-processing' : ''}` }
        >
            <WpBlockCwcSlide
                { ...JSON.parse( attributes ) }
                {...innerBlockProps}
            >
                { innerBlock }
            </WpBlockCwcSlide>
        </div>
    )
}